import { onDocumentReady } from '../vite/src/onDocumentReady'
import lightGallery from 'lightgallery'

import lgThumbnail from 'lightgallery/plugins/thumbnail'
import lgZoom from 'lightgallery/plugins/zoom'
import lgAutoplay from 'lightgallery/plugins/autoplay'
import lgFullscreen from 'lightgallery/plugins/fullscreen'

onDocumentReady(() => {
    const galleries = document.querySelectorAll('[data-gallery]')
    if (galleries.length > 0) {
        galleries.forEach((gallery) => {
            const options = typeof gallery.dataset.gallery === 'string' ? JSON.parse(gallery.dataset.gallery) : gallery.dataset.gallery
            lightGallery(
                gallery,
                {
                    plugins: [
                        lgThumbnail,
                        lgZoom,
                        lgAutoplay,
                        lgFullscreen
                    ],
                    licenseKey: 'D1EE52BE-E569-4684-A5D8-09D5AE0E84E0',
                    ...(options || {})
                }
            )
        })
    }
})
